import clsx from 'clsx';

import BaseContainer, { type BaseContainerProps } from '@commons/containers/BaseContainer';

import styles from './index.module.scss';

// Type definition for Iframe component props.

type Props = BaseContainerProps & {
  source: string;
  allow?: string;
  height?: number;
  aspectRatio?: string;
};

/**
 * Iframe component.
 */

const Iframe = (props: Props) => {
  const {
    source,
    allow = 'geolocation; microphone; camera',
    height,
    aspectRatio,
    className,
    ...rest
  } = props;

  return (
    <BaseContainer width={12} theme="white" {...rest}>
      <iframe
        src={source}
        allow={allow}
        height={height}
        className={clsx(styles.iframe, className)}
        style={{ aspectRatio }}
      />
    </BaseContainer>
  );
};

export default Iframe;
